const config = {
  appUrl: 'http://localhost:3000',
  // apiUrl : "https://api.webweb.ai"
  apiUrl: 'https://clockyapi.skyq.tech',
  devapi: 'https://api.airmsg.me/api/'
}

export default config
